document.addEventListener('DOMContentLoaded', function () {
  var endlessScroll = null;
  if (document.querySelector('[data-infinite-scroll="true"]') && typeof Ajaxinate !== 'undefined') {
    endlessScroll = new Ajaxinate({
      container: '.product-grid',
      pagination: '.pagination'
    });

    document.addEventListener('filters-applied', function () {
      if (typeof Ajaxinate !== 'undefined') {
        endlessScroll = new Ajaxinate({
          container: '.product-grid',
          pagination: '.pagination'
        });
      }
    });
  }

  var swiperInstances = [];
  var refreshScheduled = false;

  function refreshSwipers() {
    swiperInstances.forEach(function (swiper) {
      if (swiper && !swiper.destroyed) {
        swiper.update();
      }
    });
  }

  function scheduleRefreshSwipers() {
    if (refreshScheduled) return;
    refreshScheduled = true;
    requestAnimationFrame(function () {
      refreshScheduled = false;
      refreshSwipers();
    });
  }

  function whenSwiperCssReady(callback) {
    if (!document.querySelector('#reviews, #related-catalogs')) {
      callback();
      return;
    }

    var done = false;
    function run() {
      if (done) return;
      done = true;
      callback();
    }

    var deferredLink = document.querySelector('link[data-deferred-swiper-css]');
    if (deferredLink && deferredLink.sheet) {
      run();
      return;
    }

    if (deferredLink) {
      deferredLink.addEventListener('load', run, { once: true });
    }
    window.addEventListener('fq:swiper-css:loaded', run, { once: true });
  }

  function initSwipers() {
    if (typeof Swiper === 'undefined') return;

    var productSliderEl = document.querySelector('#reviews .product-slider');
    if (productSliderEl) {
      var swiperMain = new Swiper(productSliderEl, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: {
          delay: 2500,
          disableOnInteraction: true
        },
        navigation: {
          nextEl: '#reviews .product-slider .swiper-button-next',
          prevEl: '#reviews .product-slider .swiper-button-prev'
        }
      });
      swiperInstances.push(swiperMain);

      var reviewsSliderEl = document.querySelector('#reviews .review-items-slider');
      if (reviewsSliderEl) {
        var swiperReviews = new Swiper(reviewsSliderEl, {
          slidesPerView: 1,
          autoHeight: true,
          effect: 'fade',
          fadeEffect: { crossFade: true }
        });
        swiperInstances.push(swiperReviews);

        swiperMain.on('slideChange', function () {
          swiperReviews.slideToLoop(swiperMain.realIndex);
        });

        swiperReviews.on('slideChange', function () {
          swiperMain.slideToLoop(swiperReviews.realIndex);
        });
      }
    }

    if (window.innerWidth < 768) {
      var relatedCatalogs = document.getElementById('related-catalogs');
      var catalogWrapper = relatedCatalogs && relatedCatalogs.querySelector('.catalog-wrapper');

      if (catalogWrapper && !catalogWrapper.classList.contains('swiper')) {
        catalogWrapper.classList.add('swiper');

        var controls = document.createElement('div');
        controls.innerHTML = '<div class="pagination-container"><span class="swiper-pagination-bullet swiper-pagination-bullet-active"></span><span class="swiper-pagination-bullet"></span><span class="swiper-pagination-bullet"></span><span class="swiper-pagination-bullet"></span></div><div id="prev-related-catalog" class="swiper-button-prev horizontal swiper-button-disabled" aria-label="Previous"></div><div id="next-related-catalog" class="swiper-button-next horizontal" aria-label="Next"></div>';
        catalogWrapper.appendChild(controls);

        var catalogGrid = catalogWrapper.querySelector('.catalog-grid');
        if (catalogGrid) {
          catalogGrid.classList.add('swiper-wrapper');
        }

        relatedCatalogs.querySelectorAll('.catalog-item').forEach(function (item) {
          item.classList.add('swiper-slide');
        });

        requestAnimationFrame(function () {
          var swiperCatalog = new Swiper(catalogWrapper, {
            slidesPerView: 1.9,
            observer: true,
            observeParents: true,
            navigation: {
              nextEl: '#next-related-catalog',
              prevEl: '#prev-related-catalog'
            },
            pagination: {
              el: catalogWrapper.querySelector('.pagination-container'),
              clickable: true
            }
          });
          swiperInstances.push(swiperCatalog);
        });

        relatedCatalogs.querySelectorAll('.catalog-item img').forEach(function (img) {
          if (img.complete) return;
          img.addEventListener('load', scheduleRefreshSwipers, { once: true });
        });
      }
    }
  }

  whenSwiperCssReady(initSwipers);

  if (window.innerWidth < 768) {
    $(document).on('click', '.product-card .open-details, .product-card .hide-details', function () {
      var $this = $(this);
      var $card = $this.closest('.product-card');

      if ($this.hasClass('open-details')) {
        $this.removeClass('open-details').addClass('hide-details');
      } else {
        $this.removeClass('hide-details').addClass('open-details');
      }

      $card.toggleClass('active');
    });
  }

  if (window.innerWidth < 1024) {
    var sidebarTicking = false;

    function updateSidebarHeight() {
      if (window.innerWidth >= 1024) return;

      var header = document.querySelector('.header-group');
      if (!header) return;

      var headerRect = header.getBoundingClientRect();
      var visibleHeaderHeight = Math.max(0, headerRect.bottom);
      var sidebarHeight = window.innerHeight - visibleHeaderHeight;
      document.documentElement.style.setProperty('--sidebar-height', sidebarHeight + 'px');
    }

    function onSidebarLayoutChange() {
      if (sidebarTicking) return;
      sidebarTicking = true;
      requestAnimationFrame(function () {
        sidebarTicking = false;
        updateSidebarHeight();
      });
    }

    onSidebarLayoutChange();
    window.addEventListener('resize', onSidebarLayoutChange, { passive: true });
    window.addEventListener('scroll', onSidebarLayoutChange, { passive: true });

    $(document).on('click', 'button.sort-button', function () {
      $(document).find('.cc-filters-container').addClass('open-sort');
      $(document).find('details.cc-filter--sort').addClass('custom-open');
    });

    $(document).on('click', 'details.cc-filter--sort label', function () {
      $(document).find('.cc-filters-container').removeClass('open-sort');
      $(document).find('details.cc-filter--sort').removeClass('custom-open');
    });

    $(document).on('click', '.cc-sort-label button.custom-close-sort', function () {
      $(document).find('.cc-filters-container').removeClass('open-sort');
      $(document).find('details.cc-filter--sort').removeClass('custom-open');
    });

    $(document).on('click', '.filters-open .main-nav-bar', function () {
      $(document).find('button.cc-filter-close-btn').click();
    });
  }

  if (window.innerWidth >= 1025) {
    var body = document.body;
    var header = document.querySelector('.header-group');
    var filterOffsetTicking = false;

    function syncDesktopFilterOffset() {
      if (!header) return;

      var headerRect = header.getBoundingClientRect();
      var headerHidden = headerRect.bottom <= 0;
      body.classList.toggle('collection-header-hidden', headerHidden);
    }

    function onFilterOffsetChange() {
      if (filterOffsetTicking) return;
      filterOffsetTicking = true;
      requestAnimationFrame(function () {
        filterOffsetTicking = false;
        syncDesktopFilterOffset();
      });
    }

    onFilterOffsetChange();
    window.addEventListener('scroll', onFilterOffsetChange, { passive: true });
    window.addEventListener('resize', onFilterOffsetChange, { passive: true });
  }
});
